import React from 'react';
import SetupAccountsStep from 'components/AccountConnectionFlow/SetupAccountsStep';

const SetUpTiktokAccountsStep = (props) => {
  return <SetupAccountsStep />;
};

export default SetUpTiktokAccountsStep;
